(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twc-el-aullido"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(section){
    if (section.dataset.twcawInit === 'true') return;
    section.dataset.twcawInit = 'true';
    var storeKey = 'twcAullido_' + section.id;
    var path = section.querySelector('.twc-aw__orbit-path');
    var car = section.querySelector('[data-car]');
    var phases = section.querySelectorAll('.twc-aw__phase');
    var hud = section.querySelector('[data-hud]');
    var startBtn = section.querySelector('[data-start]');
    var stopBtn = section.querySelector('[data-stop]');
    var hint = section.querySelector('[data-hint]');
    var result = section.querySelector('[data-result]');
    var badge = section.querySelector('[data-badge]');
    var timeEl = section.querySelector('[data-time]');
    var emailStep = section.querySelector('[data-email-step]');
    var emailInput = section.querySelector('[data-email-input]');
    var emailSubmit = section.querySelector('[data-email-submit]');
    var emailError = section.querySelector('[data-email-error]');
    var codeStep = section.querySelector('[data-code-step]');
    var codeValue = section.querySelector('[data-code-value]');
    var codeDesc = section.querySelector('[data-code-desc]');
    var copyBtn = section.querySelector('[data-copy]');
    var playedPanel = section.querySelector('[data-played]');
    var playedCode = section.querySelector('[data-played-code]');
    var playedCopy = section.querySelector('[data-played-copy]');
    if (!path || !car) return;
    var totalLen = path.getTotalLength();
    var lapMs = parseInt(section.dataset.lap,10) || 2800;
    var diff = section.dataset.difficulty || 'medio';
    var replay = section.dataset.replay || 'once';
    var tiers = { facil:{t1:0.05,t2:0.12}, medio:{t1:0.03,t2:0.08}, dificil:{t1:0.015,t2:0.05} }[diff] || {t1:0.03,t2:0.08};
    var codes = {
      1:{code:section.dataset.t1Code||'ALFA15',badge:section.dataset.t1Badge||'¡Aullido Alfa!',desc:section.dataset.t1Desc||'15% de descuento'},
      2:{code:section.dataset.t2Code||'CAZADOR10',badge:section.dataset.t2Badge||'¡Buen instinto!',desc:section.dataset.t2Desc||'10% de descuento'},
      3:{code:section.dataset.t3Code||'MANADA5',badge:section.dataset.t3Badge||'¡Bienvenido a la manada!',desc:section.dataset.t3Desc||'5% de descuento'}
    };
    function getSaved(){ try { return JSON.parse(localStorage.getItem(storeKey)||'null'); } catch(e){ return null; } }
    function canPlay(){
      if (replay==='free') return true;
      var s=getSaved(); if (!s) return true;
      if (replay==='daily'){ return s.date !== new Date().toISOString().slice(0,10); }
      return false;
    }
    function saveResult(tier){
      try { localStorage.setItem(storeKey, JSON.stringify({tier:tier,code:codes[tier].code,date:new Date().toISOString().slice(0,10),ts:Date.now()})); } catch(e){}
    }
    function pointAt(frac){ return path.getPointAtLength((((frac%1)+1)%1)*totalLen); }
    function setCarAt(frac){ var p=pointAt(frac); car.setAttribute('transform','translate('+p.x.toFixed(1)+','+p.y.toFixed(1)+')'); }
    setCarAt(0);
    if (!canPlay()){
      var s0=getSaved(); if (s0 && playedCode){ playedCode.textContent=s0.code; }
      section.setAttribute('data-state','played'); playedPanel.hidden=false;
    }
    var raf=null, startTime=0, running=false;
    function loop(now){ if(!running) return; setCarAt(((now-startTime)%lapMs)/lapMs); raf=requestAnimationFrame(loop); }
    function startCountdown(){
      section.setAttribute('data-state','countdown'); startBtn.hidden=true; hint.textContent='Afina el instinto...';
      var i=0; phases.forEach(function(l){ l.classList.remove('is-on'); });
      var iv=setInterval(function(){
        if (i<phases.length){ phases[i].classList.add('is-on'); i++; return; }
        clearInterval(iv);
        setTimeout(function(){ phases.forEach(function(l){ l.classList.remove('is-on'); }); beginRun(); }, 320+Math.random()*460);
      }, 560);
    }
    function beginRun(){
      section.setAttribute('data-state','running'); running=true; startTime=performance.now();
      stopBtn.hidden=false; hud.classList.add('is-visible'); hud.textContent='¡AÚLLA!';
      hint.textContent='Detén el lobo al tocar la luna'; raf=requestAnimationFrame(loop);
    }
    function stopRun(){
      if(!running) return; running=false; if(raf) cancelAnimationFrame(raf);
      var frac=((performance.now()-startTime)%lapMs)/lapMs; setCarAt(frac);
      var gap=Math.min(frac,1-frac), gapMs=gap*lapMs, tier=3;
      if (gap<=tiers.t1) tier=1; else if (gap<=tiers.t2) tier=2;
      stopBtn.hidden=true; hud.classList.remove('is-visible'); showResult(tier,gapMs);
    }
    function showResult(tier,gapMs){
      section.setAttribute('data-state','result'); result.hidden=false;
      badge.textContent=codes[tier].badge;
      timeEl.textContent='Distancia a la luna: +'+(gapMs/1000).toFixed(3)+'s';
      result.dataset.tier=tier; emailStep.hidden=false; codeStep.hidden=true;
    }
    function revealCode(tier){
      codeStep.hidden=false; emailStep.hidden=true;
      codeValue.textContent=codes[tier].code; codeDesc.textContent=codes[tier].desc; saveResult(tier);
    }
    function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
    function captureEmail(email){
      var tags=section.dataset.emailTags||'newsletter,el-aullido';
      var body=new URLSearchParams();
      body.append('form_type','customer'); body.append('utf8','\u2713');
      body.append('contact[email]',email); body.append('contact[tags]',tags);
      return fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},body:body.toString()}).catch(function(){});
    }
    if (emailSubmit){
      emailSubmit.addEventListener('click', function(){
        var v=(emailInput.value||'').trim();
        if(!validEmail(v)){ emailError.hidden=false; emailInput.focus(); return; }
        emailError.hidden=true; emailSubmit.disabled=true; emailSubmit.textContent='...';
        var tier=parseInt(result.dataset.tier,10)||3;
        captureEmail(v).then(function(){ revealCode(tier); });
      });
      emailInput.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); emailSubmit.click(); } });
    }
    function wireCopy(btn,getText){
      if(!btn) return;
      btn.addEventListener('click', function(){
        var txt=getText();
        var done=function(){ btn.textContent='¡Copiado!'; btn.classList.add('is-copied'); setTimeout(function(){ btn.textContent='Copiar'; btn.classList.remove('is-copied'); },1800); };
        if(navigator.clipboard){ navigator.clipboard.writeText(txt).then(done).catch(done); } else { done(); }
      });
    }
    wireCopy(copyBtn, function(){ return codeValue.textContent; });
    wireCopy(playedCopy, function(){ return playedCode.textContent; });
    if (startBtn) startBtn.addEventListener('click', startCountdown);
    if (stopBtn) stopBtn.addEventListener('click', stopRun);
  }
  function initAll(){ document.querySelectorAll('[data-section-type="twc-aw"]').forEach(init); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function(e){
    var s=e.target.querySelector('[data-section-type="twc-aw"]'); if(s){ s.dataset.twcawInit=''; init(s); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
